import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db3047b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { separator: ">" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.meteItems, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
            key: index,
            class: _normalizeClass([
          {
            'act-status':
              (index == 0 && $props.meteItems.length == 2) ||
              ($props.meteItems.length == 3 && (index == 0 || index == 1)),
          },
          { textcolor: $props.meteItems.length - 1 === index },
        ]),
            onClick: ($event: any) => ($setup.jumpRouter(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}